import { useState, useMemo } from 'react';
import * as LucideIcons from 'lucide-react';
import { Table } from '../../shared/table';
import { SearchBar } from '../../shared';
import { File } from '../../../types/files';
import { mockFiles } from '../../../data/mockFilesData';
import { useFilesTableConfig } from '../../Files/hooks';

interface GroupFilesProps {
  groupName: string;
}

export function GroupFiles({ groupName }: GroupFilesProps) {
  const [searchQuery, setSearchQuery] = useState('');

  // Use the shared table config hook with group page flag
  const columns = useFilesTableConfig({ isGroupPage: true });

  // Filter files to current group
  const groupFiles = useMemo(() => {
    return mockFiles.filter(file => file.group === groupName);
  }, [groupName]);

  // Filter based on search query
  const filteredFiles = useMemo(() => {
    if (!searchQuery.trim()) return groupFiles;

    const query = searchQuery.toLowerCase();
    return groupFiles.filter(file =>
      file.filename.toLowerCase().includes(query) ||
      file.description.toLowerCase().includes(query) ||
      file.uploadedBy.toLowerCase().includes(query) ||
      file.type.toLowerCase().includes(query)
    );
  }, [groupFiles, searchQuery]);

  const handleRowClick = (file: File) => {
    console.log('Open file:', file);
  };

  return (
    <div>
      {/* Search Bar */}
      <div className="flex items-center gap-3 mb-6">
        <div style={{ flex: 1, minWidth: 0 }}>
          <SearchBar
            onSearchChange={setSearchQuery}
            placeholder="Search by filename, description, or uploader..."
            width="100%"
            dataTarget="files-search-input"
          />
        </div>
        <button
          onClick={() => console.log('Upload file')}
          className="inline-flex items-center justify-center gap-2 w-[38px] h-[38px] md:w-auto md:h-auto md:px-3 md:py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-sm hover:bg-gray-50 whitespace-nowrap"
          data-pp-at-target="upload-file-button"
        >
          <LucideIcons.Upload size={16} />
          <span className="hidden md:inline">Upload File</span>
        </button>
      </div>

      {/* Files Table */}
      <Table<File>
        data={filteredFiles}
        columns={columns}
        getRowKey={(file) => file.id}
        usePagination={true}
        pageSize={10}
        emptyMessage="No files found for this group"
        onRowClick={handleRowClick}
      />
    </div>
  );
}
